import { useEffect, useRef, useState } from 'react';
import ReactModal from "react-modal";

// table react component
const App = ({ data }) => {
    const { id, soci_ctm_formbuilder_id } = data;

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [iframeHeight, setIframeHeight] = useState("auto");
    const [iframeWidth, setIframeWidth] = useState("auto");
    const [iframeVisiblity, setIframeVisiblity] = useState("hidden");
    const iframeRef = useRef(null);

    const href = `/patient-services/request-an-appointment/?location-id=${id}`;

    ReactModal.setAppElement("#location-appointment-button");

    useEffect(() => {
        const handleMessage = (event) => {
            // console.log("EVENT", event);
            if (event?.data?.action === "resize" && iframeRef.current) {
                const width = event.data.width;
                const height = event.data.height;

                setIframeHeight((Number(height) + 42) + "px");
                setIframeWidth(width + "px");
                setIframeVisiblity("visible");
            }
        };

        if (isModalOpen) {
            window.addEventListener("message", handleMessage);
        }

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, [isModalOpen]);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className="location-appointment-button">

            <a
                href={href}
                class="wp-block-create-block-location-appointment-button__link wp-element-button location-appointment-button"
                onClick={(e) => {
                    if (soci_ctm_formbuilder_id) {
                        e.preventDefault();
                        openModal();
                    }

                }}
            >
                Request Appointment
            </a>
            <ReactModal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                style={{
                    content: {
                        width: iframeWidth,
                        height: iframeHeight,
                        margin: "auto",
                        overflow: "hidden",
                    },
                    overlay: {
                        zIndex: 1000,
                    },
                }}
            >
                <span class="close-btn" onClick={closeModal}>
                    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"/></svg>
                </span>
                <iframe
                    ref={iframeRef}
                    className="ctm-call-widget"
                    data-src={`https://117910.tctm.co/form/${soci_ctm_formbuilder_id}.html`}
                    src={`https://117910.tctm.co/form/${soci_ctm_formbuilder_id}.html`}
                    style={{
                        visibility: iframeVisiblity,
                        width: "100%",
                        height: iframeHeight,
                        border: "none",
                    }}
                ></iframe>
            </ReactModal>
        </div>
    );
};

export default App;
